'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.microsoftTeamsAuthorisationWidget = function (config, navigatorShim, authenticationModel) {
	if (!config || !navigatorShim || !authenticationModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const widget = this,
			directLink = widget.find('[data-mm-role~="direct-link"]'),
			visibleLink = widget.find('[data-mm-role~="visible-link"]');
		authenticationModel.addEventListener('authenticatedProfile', profile => {
			if (!profile || !profile.provider || profile.provider !== 'microsoft' || !profile.providerProfile || !profile.providerProfile.orgId) {
				directLink.attr('href', '');
				visibleLink.text('');
				return;
			}
			const link = `https://login.microsoftonline.com/${profile.providerProfile.orgId}/adminConsent?client_id=${config.microsoftAppId}&redirect_uri=${navigatorShim.getOrigin()}/ms-teams-redirect.html`;
			directLink.attr('href', link);
			visibleLink.text(link);
		});
	});
};
